<!--拷贝供应商发货指令-->
<template>
  <SelectTableDialog
    :title="$t('logistics.searchTable.instructionNo')"
    :searchColumns="searchColumns"
    :columnList="columnList"
    :defaultVisible="defaultVisible"
    :API="API"
    :extraData="extraData"
    :confirmUnchecked="false"
    :isMultiple="false"
    width="1200px"
    @close="close"
    @confirm="creatOrder"
  ></SelectTableDialog>
</template>

<script>
  // import { mapState } from 'vuex';
  import API from '@/api/logisticsCenter/logisticsReceiptList.js';
  import SelectTableDialog from '@/components/SelectTableDialog';
  export default {
    name: 'searchTable',
    components: {
      SelectTableDialog,
    },
    computed: {
      searchColumns() {
        return [
          {
            prop: 'instructionNo',
            name: this.$t('logistics.searchTable.instructionNo'),
            type: 'input',
          },
          {
            prop: 'searchContractNo',
            name: this.$t('logistics.commodityMarket.purchaseNo'),
            type: 'input',
          },
          {
            prop: 'searchIntentNo',
            name: this.$t('logistics.commodityMarket.searchIntentNo'),
            type: 'input',
          },
          {
            type: 'searchTableSpec',
            name: this.$t('logistics.logisticsReceiptList.givePerson'),
            prop: 'partnerNo',
            searchType: 'supplier',
            isMultiple: true,
            getSearchCode: 'partnerCode',
          },
          {
            prop: 'compareLessZeroFlag',
            name: this.$t('logistics.logisticsReceiptList.compareLessZeroFlag'),
            type: 'checkbox',
            falseLable: 0,
            trueLable: 1,
            isChecked: true,
          },
          {
            prop: 'compareEqualZeroFlag',
            name: this.$t('logistics.logisticsReceiptList.compareEqualZeroFlag'),
            type: 'checkbox',
            falseLable: 0,
            trueLable: 1,
            isChecked: true,
          },
          {
            type: 'searchTableSpec',
            name: this.$t('logistics.returnOrderTable.searchTableSpec'),
            prop: 'storageNo',
            searchType: 'warehouse',
            isMultiple: true,
            getSearchCode: 'storageCode',
          },
        ];
      },
      columnList() {
        return [
          {
            prop: 'instructionNo',
            label: this.$t('logistics.searchTable.instructionNo'),
          },
          {
            prop: 'storageName',
            label: this.$t('logistics.searchTable.storageName'),
          },
          {
            prop: 'productDesc',
            label: this.$t('logistics.returnOrderTable.productDesc'),
          },
          {
            prop: 'deliverMethod',
            label: this.$t('logistics.searchTable.deliverMethod'),
            render: (value, row) => this.renderDeliverMethod(value, row),
          },
          {
            prop: 'instructionNumber',
            label: this.$t('logistics.searchTable.instructionNumber'),
          },
          {
            prop: 'remainingNumber',
            label: this.$t('logistics.searchTable.remainingQuantityIn'),
          },
          {
            prop: 'distributionModeName',
            label: this.$t('logistics.transportationInformation.shippingMethod'),
          },
          {
            prop: 'instructionDepartmentName',
            label: this.$t('logistics.logisticsReceiptList.inboundDepartmentNo'),
          },
          {
            prop: 'salesmanName',
            label: this.$t('logistics.logisticsReceiptList.salesmanNoList'),
          },
          {
            prop: 'partnerName',
            label: this.$t('logistics.logisticsReceiptList.givePerson'),
          },
          {
            prop: 'deliverDate',
            label: this.$t('logistics.searchTable.deliverDate'),
          },
          {
            prop: 'purchaseContractNo',
            label: this.$t('logistics.logisticsReceiptList.purchaseContractNo'),
          },
          {
            prop: 'purchaseIntentNo',
            label: this.$t('logistics.searchTable.purchaseIntentNo'),
          },
        ];
      },
    },
    data() {
      return {
        defaultVisible: false,
        API: API.CREAT_FILE_API,
        extraData: {
          // 查询已生效的
          selectFlag: '01',
        },
        deliverMethod: {
          0: this.$t('logistics.searchTable.supplierDistribution'),
          1: this.$t('logistics.searchTable.selfProduction'),
          2: this.$t('logistics.searchTable.CustomerSelfMention'),
          3: this.$t('logistics.searchTable.libraryTurn'),
        },
      };
    },
    mounted() {},
    methods: {
      renderDeliverMethod(value) {
        return this.deliverMethod[value];
      },
      // 弹窗关闭
      close() {
        this.defaultVisible = false;
      },
      //跳转编辑页
      creatOrder(selections) {
        if (selections.length !== 0 && selections[0]) {
          this.defaultVisible = false;
          let path = {
            path: '/logistics/logisticsRevise',
            name: 'logisticsRevise',
            meta: {
              keepAlive: true,
              title: this.$t('logistics.logisticsRevise.logisticsRevise'),
            },
            query: {
              instructionNo: selections[0].instructionNo,
              number: '1',
              returnType: selections[0].returnType,
              returnNo: selections[0].returnNo,
              inboundType: 'RK01', //采购
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else {
          this.$message({
            message: this.$t('logistics.searchTable.creatTranstionOrder'),
            type: 'error',
          });
        }
        //  else if (selections.length>1) {
        //   this.$message({
        //     message: "不可合并创建",
        //     type: "error"
        //   });
        // }
      },
    },
  };
</script>
